import '../math/Graph.js';
import '../math/Shapes.js';
import { MatrixVector, Matrix } from '../math/Matrix.js';

class Translation {
    constructor(x, y) {
        this.x = x;
        this.y = y;
    }
    toMatrixVector() {
        return new MatrixVector(0, 0, 0, 0, this.x, this.y);
    }
    toMatrix() {
        return Matrix.translation(this.x, this.y);
    }
    toString() {
        return `translate(${this.x},${this.y})`;
    }
    plus(delta) {
        this.x += delta.x;
        this.y += delta.y;
    }
    times(factor) {
        this.x *= factor;
        this.y *= factor;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    normalize() {
        if (this.Length === 0) {
            return;
        }
        this.times(1 / this.length());
    }
    invert() {
        return new Translation(-this.x, -this.y);
    }
}

export { Translation };
